// src/pages/CalendarPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { postsAPI } from '../utils/api';
import { format, startOfMonth, endOfMonth, eachDayOfInterval, getDay, isSameMonth, isToday } from 'date-fns';
import { getPlatform } from '../utils/platforms';

export default function CalendarPage() {
  const navigate = useNavigate();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [calPosts, setCalPosts] = useState([]);

  useEffect(() => {
    const month = format(currentDate, 'yyyy-MM');
    postsAPI.calendar(month).then(r => setCalPosts(r.data.posts)).catch(() => {});
  }, [currentDate]);

  const monthStart = startOfMonth(currentDate);
  const monthEnd = endOfMonth(currentDate);
  const days = eachDayOfInterval({ start: monthStart, end: monthEnd });
  const startPad = getDay(monthStart);

  const getPostsForDay = (day) => calPosts.filter(p => p.scheduled_at && format(new Date(p.scheduled_at), 'yyyy-MM-dd') === format(day, 'yyyy-MM-dd'));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="page-header">
        <span className="page-title">Calendar</span>
        <button className="btn btn-primary" onClick={() => navigate('/posts/create')}>+ Create Post</button>
      </div>
      <div className="toolbar">
        <div className="search-box"><span style={{ color: '#aaa' }}>🔍</span><input placeholder="Search a Post" /></div>
        <button className="filter-pill">⚡ Filter Posts</button>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
          <button style={{ width: 26, height: 26, border: '1px solid #e2e5ed', borderRadius: 5, background: '#fff', cursor: 'pointer', fontSize: 15 }} onClick={() => setCurrentDate(d => new Date(d.getFullYear(), d.getMonth() - 1, 1))}>‹</button>
          <span style={{ fontSize: 13, fontWeight: 600, color: '#1a1f2e', minWidth: 100, textAlign: 'center' }}>{format(currentDate, 'MMMM yyyy')}</span>
          <button style={{ width: 26, height: 26, border: '1px solid #e2e5ed', borderRadius: 5, background: '#fff', cursor: 'pointer', fontSize: 15 }} onClick={() => setCurrentDate(d => new Date(d.getFullYear(), d.getMonth() + 1, 1))}>›</button>
        </div>
        <div className="vm-group">
          <div className="vm" onClick={() => navigate('/posts/manage')}>List</div>
          <div className="vm">Day</div><div className="vm">Week</div>
          <div className="vm active">Month</div>
        </div>
      </div>
      <div style={{ flex: 1, overflowY: 'auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', borderTop: '1px solid #e8eaf0', borderLeft: '1px solid #e8eaf0' }}>
          {['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'].map(d => (
            <div key={d} style={{ padding: 7, textAlign: 'center', fontSize: 11, fontWeight: 600, color: '#8892a4', background: '#f8f9fb', borderRight: '1px solid #e8eaf0', borderBottom: '1px solid #e8eaf0' }}>{d}</div>
          ))}
          {Array.from({ length: startPad }).map((_, i) => {
            const prevDay = new Date(monthStart); prevDay.setDate(prevDay.getDate() - startPad + i);
            return <div key={`pad-${i}`} style={{ minHeight: 90, padding: 5, borderRight: '1px solid #e8eaf0', borderBottom: '1px solid #e8eaf0', background: '#fafafa' }}><div style={{ fontSize: 11, color: '#ccc' }}>{prevDay.getDate()}</div></div>;
          })}
          {days.map(day => {
            const dayPosts = getPostsForDay(day);
            const today = isToday(day);
            return (
              <div key={day.toISOString()} style={{ minHeight: 90, padding: 5, borderRight: '1px solid #e8eaf0', borderBottom: '1px solid #e8eaf0', background: '#fff', cursor: 'pointer' }} onClick={() => navigate('/posts/create')}>
                <div style={{ width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: today ? '#fff' : '#444', background: today ? '#0f766e' : 'transparent', borderRadius: '50%', marginBottom: 3 }}>{day.getDate()}</div>
                {dayPosts.slice(0, 3).map((p, i) => {
                  const plt = p.platforms?.[0];
                  const pl = getPlatform(plt);
                  return (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 3, padding: '2px 4px', background: '#eef4ff', borderRadius: 3, marginBottom: 2, fontSize: 9, color: '#1a3a70', overflow: 'hidden' }}>
                      <div style={{ width: 7, height: 7, borderRadius: '50%', background: pl.color, flexShrink: 0 }} />
                      <span style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{p.caption?.slice(0, 20)}…</span>
                      <span style={{ marginLeft: 'auto', flexShrink: 0, color: '#8892a4' }}>{format(new Date(p.scheduled_at), 'h:mm a')}</span>
                    </div>
                  );
                })}
                {dayPosts.length > 3 && <div style={{ fontSize: 9, color: '#0f766e', cursor: 'pointer' }}>+{dayPosts.length - 3} more</div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
